module.exports = __webpack_public_path__ + "static/media/MakingWishes.2e72d2ba.jpg";